export default {
    name: "imagen",
    components: {},
    data() {
        return {
            url: ""
        };
    },

    computed: {},

    async mounted() {
        this.url = this.$route.params.url;
        //window.console.log("IMAGE MOUNTED", this.url);
    },

    methods: {}
};
